import React, {useEffect, useState} from "react"
import {Form} from "react-bootstrap"
import {Controller, useForm} from "react-hook-form";
import {useNavigate} from "react-router";
import DescriptionField from "../../../../components/common/description-field/DescriptionField";
import ThemeButton from "../../../../components/common/theme-button/ThemeButton";
import {checkEmptySpaces, maxLength, Required} from "../../../../utils/patterns";
import "./add-gratitude.scss"
import {GratitudeService} from "../../../../services/gratitude-api.service";
import {QuestionService} from "../../../../services/questions-api.service";
import {CloseRoundedCheck, RoundedCheck} from "../../../../../assets/icons/defaultIcons";
import {notification} from "antd";
import {useUser} from "../../../../providers/UserContext";

export default function AddGratitude({close, getListing, setGetListing}) {
    const[loader,setLoader] = useState(false);
    const[question,setQuestion] = useState(false);
    const {pointUpdate , setPointUpdate} = useUser();
    const {
        handleSubmit,
        reset,
        formState: {errors, isValid},
        control,
    } = useForm({
        mode: 'onChange',
    })
    const navigate = useNavigate()

    const questionPayload = {
        category: 'gratitude',
    }

    async function GetQuestion(payload) {
        const response = await QuestionService.getQuestion(payload);
        if(response?.data?.status) {
            setQuestion(response?.data?.data?.data)
        }
    }

    useEffect(()=>{
        GetQuestion(questionPayload)
    },[])

    const onSubmit = async (data) => {
        setLoader(true)

        if(data){
            let dummyQuestion = question;

            let payload = {
                questionId: dummyQuestion[0]._id,
                content: [
                    {
                        label: dummyQuestion[0].multiQuestions[0],
                        text: data.des
                    }
                ]
            }

            const response = await GratitudeService.createGratitude(payload)

            if (response?.data?.data?.status){
                notification.success({
                    message: "Success",
                    description: "Gratitude added Successfully",
                    placement: "topRight",
                    icon: <RoundedCheck/>,
                    duration: 2,
                });
                setGetListing(!getListing)
                setLoader(false)
                setPointUpdate(!pointUpdate)
                reset()
                close(false)
            }
            else{
                notification.error({
                    message: "Failed",
                    description: "Gratitude Failed to Add",
                    placement: "topRight",
                    icon: <CloseRoundedCheck/>,
                    duration: 2,
                });
            }

        }

    }


    return(
        <div className={'add-gratitude'}>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className={'dfields'}>
                    <Controller
                        name="des"
                        defaultValue={''}
                        control={control}
                        rules={{required:Required, maxLength: maxLength(2000) , validate:checkEmptySpaces}}
                        render={({field: {name, ...field}}) => (
                            <DescriptionField
                                placeholder={'I am grateful for...'}
                                type={'text'}
                                defaultValue={field.value}
                                field={field}
                                errors={errors.des}
                                autoSize={{ minRows: 12, maxRows: 12 }}
                            />
                        )}
                    />
                </div>
                <div className={'mt-30'}>
                    <ThemeButton
                        text={'Submit'}
                        type={'submit'}
                        className={'btn-light-lg'}
                        loader={loader}
                    />
                </div>
            </Form>
        </div>
    )
}